webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(3);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App',
	      isFixed: false,
	      menuIndex: 0,
	      menuList: [],
	      indexHeight: [0]
	    };
	  },
	  created: function created() {
	    this.menuList = data.menuList;
	  },
	  mounted: function mounted() {
	    var me = this;
	    new Swiper('.swiper-container', {
	      loop: true,
	      direction: 'horizontal',
	      speed: 500,
	      autoplay: 5000,
	      autoplayDisableOnInteraction: false,
	      pagination: '.swiper-pagination',
	      paginationClickable: true
	    });
	    for (var i = 1; i <= this.menuList.length; i++) {
	      var el = document.getElementById(i.toString());
	      this.indexHeight.push(el.offsetTop - 60);
	    }
	    window.onscroll = function () {
	      var t = document.documentElement.scrollTop || document.body.scrollTop;
	      if (t >= 115) me.isFixed = true;else me.isFixed = false;
	      for (var i = 0; i < me.indexHeight.length; i++) {
	        if (t >= me.indexHeight[i] && t < me.indexHeight[i + 1]) me.menuIndex = i;
	        if (t >= me.indexHeight[i]) me.menuIndex = i;
	      }
	    };
	  },
	
	  methods: {
	    menuEvent: function menuEvent(id) {
	      var el = document.getElementById(id.toString());
	      if (id === 0) $.scrollTo(0, 600, { axis: 'y' });else $.scrollTo(el.offsetTop - 60, 600, { axis: 'y' });
	    },
	    location: function location(item) {
	      if (!item.site) {
	        if (item.href) window.open(item.href);
	      }
	    },
	    officeSitEvent: function officeSitEvent(item, sign) {
	      if (sign) window.open(item.site.model);else {
	        if (item.site.official !== '') window.open(item.site.official);
	      }
	    }
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(2)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(1),
	  /* template */
	  __webpack_require__(5),
	  /* scopeId */
	  "data-v-58663a66",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "index-box"
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "box2",
	    class: {
	      'fixed': _vm.isFixed
	    }
	  }, [_c('div', {
	    staticClass: "bb"
	  }, [_c('div', {
	    staticClass: "menu"
	  }, [_c('div', {
	    staticClass: "a",
	    class: {
	      active: 0 === _vm.menuIndex
	    },
	    on: {
	      "click": function($event) {
	        _vm.menuEvent(0)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("网站首页")]), _vm._v(" "), _c('span', {
	    staticClass: "english"
	  }, [_vm._v("Home")])]), _vm._v(" "), _vm._l((_vm.menuList), function(item, index) {
	    return _c('div', {
	      staticClass: "a",
	      class: {
	        active: index + 1 === _vm.menuIndex
	      },
	      on: {
	        "click": function($event) {
	          _vm.menuEvent(index + 1)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
	      staticClass: "english"
	    }, [_vm._v(_vm._s(item.english))])])
	  })], 2)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.menuList), function(listItem, index1) {
	    return _c('div', {
	      staticClass: "kuai-box",
	      class: {
	        bgfff: index1 % 2 === 1
	      },
	      attrs: {
	        "id": index1 + 1
	      }
	    }, [_c('div', {
	      staticClass: "kuai-main"
	    }, [_c('h3', [_vm._v(_vm._s(listItem.text))]), _vm._v(" "), _c('div', {
	      staticClass: "desc"
	    }, [_vm._v(_vm._s(listItem.desc))]), _vm._v(" "), _c('div', {
	      staticClass: "list"
	    }, [_vm._l((listItem.items), function(item, index2) {
	      return _c('div', {
	        staticClass: "item",
	        class: {
	          nom: (index2 + 1) % 3 === 0
	        },
	        on: {
	          "click": function($event) {
	            _vm.location(item)
	          }
	        }
	      }, [_c('div', {
	        staticClass: "shadow"
	      }), _vm._v(" "), _c('div', {
	        staticClass: "img-box"
	      }, [_c('img', {
	        class: {
	          img: index1 === 1
	        },
	        attrs: {
	          "src": item.img
	        }
	      }), _vm._v(" "), _c('div', {
	        staticClass: "imgma-box",
	        attrs: {
	          "if": "item.imgma"
	        }
	      }, [_c('img', {
	        staticClass: "imgma",
	        attrs: {
	          "src": item.imgma
	        }
	      })])]), _vm._v(" "), _c('div', {
	        class: {
	          descinfo1: index1 === 1, descinfo: index1 !== 1
	        }
	      }, [_c('div', {
	        staticClass: "a-box"
	      }, [_c('h6', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
	        staticClass: "time"
	      }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('p', {
	        class: {
	          height: index1 === 0
	        },
	        attrs: {
	          "title": item.content
	        }
	      }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), (index1 === 0) ? _c('div', {
	        staticClass: "button"
	      }, [_c('div', {
	        staticClass: "btn",
	        on: {
	          "click": function($event) {
	            _vm.officeSitEvent(item, false)
	          }
	        }
	      }, [_vm._v("查看[官网]")]), _vm._v(" "), _c('div', {
	        staticClass: "btn",
	        on: {
	          "click": function($event) {
	            _vm.officeSitEvent(item, true)
	          }
	        }
	      }, [_vm._v("查看[模仿]")])]) : _vm._e()])])])
	    }), _vm._v(" "), _c('div', {
	      staticClass: "kong"
	    })], 2)]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "100%",
	        "height": "70px"
	      }
	    })])
	  }), _vm._v(" "), _vm._m(2)], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box1"
	  }, [_c('div', {
	    staticClass: "logo"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "banner"
	  }, [_c('div', {
	    staticClass: "swiper-container"
	  }, [_c('div', {
	    staticClass: "swiper-wrapper"
	  }, [_c('div', {
	    staticClass: "swiper-slide bg1"
	  }, [_vm._v("这世上最快的捷径就是脚踏实地")]), _vm._v(" "), _c('div', {
	    staticClass: "swiper-slide bg2"
	  }, [_vm._v("笔耕不掇，天道酬勤")]), _vm._v(" "), _c('div', {
	    staticClass: "swiper-slide bg3"
	  }, [_vm._v("十年磨一剑，一朝试锋芒")])]), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer"
	  }, [_c('div', {
	    staticClass: "bo"
	  }, [_vm._v("划船不用浆，一生全靠浪！")])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.edaff9e53aa4ab4508ff.js